import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import PromotionList from './components/PromotionList';
import StepsSection from './components/StepsSection';
import PlatformSection from './components/PlatformSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '送彩金',
  url: 'https://esgey.cn',
  description: '送彩金活动平台，提供注册送彩金、首存送彩金、签到送彩金、邀请好友送彩金等多种优惠活动',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://esgey.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  useEffect(() => {
    document.title = '送彩金·领取专属优惠彩金活动 - 注册送彩金、首存送彩金、天天送彩金';
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <PromotionList />
          <StepsSection />
          <PlatformSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}